// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"28":"data-entry","371":"connect","501":"issue-credential","882":"confirm-data"}[chunkId] + "." + {"28":"ca12f1b3","371":"342ac161","501":"f393fe1d","882":"bc402d58"}[chunkId] + ".js";
};